import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _toConsumableArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.28.4/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
var _excluded = ["children"],
  _excluded2 = ["children"];
var _HelmetProvider2, _Class3;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// src/index.tsx
import React3, { Component as Component3 } from "react";
import fastCompare from "react-fast-compare";
import invariant from "invariant";

// src/Provider.tsx
import React2, { Component } from "react";

// src/server.ts
import React from "react";

// src/constants.ts
var TAG_NAMES = /* @__PURE__ */function (TAG_NAMES2) {
  TAG_NAMES2["BASE"] = "base";
  TAG_NAMES2["BODY"] = "body";
  TAG_NAMES2["HEAD"] = "head";
  TAG_NAMES2["HTML"] = "html";
  TAG_NAMES2["LINK"] = "link";
  TAG_NAMES2["META"] = "meta";
  TAG_NAMES2["NOSCRIPT"] = "noscript";
  TAG_NAMES2["SCRIPT"] = "script";
  TAG_NAMES2["STYLE"] = "style";
  TAG_NAMES2["TITLE"] = "title";
  TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
  return TAG_NAMES2;
}(TAG_NAMES || {});
var SEO_PRIORITY_TAGS = {
  link: {
    rel: ["amphtml", "canonical", "alternate"]
  },
  script: {
    type: ["application/ld+json"]
  },
  meta: {
    charset: "",
    name: ["generator", "robots", "description"],
    property: ["og:type", "og:title", "og:url", "og:image", "og:image:alt", "og:description", "twitter:url", "twitter:title", "twitter:description", "twitter:image", "twitter:image:alt", "twitter:card", "twitter:site"]
  }
};
var VALID_TAG_NAMES = Object.values(TAG_NAMES);
var REACT_TAG_MAP = {
  accesskey: "accessKey",
  charset: "charSet",
  class: "className",
  contenteditable: "contentEditable",
  contextmenu: "contextMenu",
  "http-equiv": "httpEquiv",
  itemprop: "itemProp",
  tabindex: "tabIndex"
};
var HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce(function (carry, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    value = _ref2[1];
  carry[value] = key;
  return carry;
}, {});
var HELMET_ATTRIBUTE = "data-rh";

// src/utils.ts
var HELMET_PROPS = {
  DEFAULT_TITLE: "defaultTitle",
  DEFER: "defer",
  ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
  ON_CHANGE_CLIENT_STATE: "onChangeClientState",
  TITLE_TEMPLATE: "titleTemplate",
  PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var getInnermostProperty = function getInnermostProperty(propsList, property) {
  for (var i = propsList.length - 1; i >= 0; i -= 1) {
    var props = propsList[i];
    if (Object.prototype.hasOwnProperty.call(props, property)) {
      return props[property];
    }
  }
  return null;
};
var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
  var innermostTitle = getInnermostProperty(propsList, "title" /* TITLE */);
  var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
  if (Array.isArray(innermostTitle)) {
    innermostTitle = innermostTitle.join("");
  }
  if (innermostTemplate && innermostTitle) {
    return innermostTemplate.replace(/%s/g, function () {
      return innermostTitle;
    });
  }
  var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
  return innermostTitle || innermostDefaultTitle || void 0;
};
var getOnChangeClientState = function getOnChangeClientState(propsList) {
  return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};
var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
  return propsList.filter(function (props) {
    return typeof props[tagType] !== "undefined";
  }).map(function (props) {
    return props[tagType];
  }).reduce(function (tagAttrs, current) {
    return _objectSpread(_objectSpread({}, tagAttrs), current);
  }, {});
};
var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
  return propsList.filter(function (props) {
    return typeof props["base" /* BASE */] !== "undefined";
  }).map(function (props) {
    return props["base" /* BASE */];
  }).reverse().reduce(function (innermostBaseTag, tag) {
    if (!innermostBaseTag.length) {
      var keys = Object.keys(tag);
      for (var i = 0; i < keys.length; i += 1) {
        var attributeKey = keys[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
          return innermostBaseTag.concat(tag);
        }
      }
    }
    return innermostBaseTag;
  }, []);
};
var warn = function warn(msg) {
  return console && typeof console.warn === "function" && console.warn(msg);
};
var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
  var approvedSeenTags = {};
  return propsList.filter(function (props) {
    if (Array.isArray(props[tagName])) {
      return true;
    }
    if (typeof props[tagName] !== "undefined") {
      warn("Helmet: ".concat(tagName, " should be of type \"Array\". Instead found type \"").concat(typeof props[tagName], "\""));
    }
    return false;
  }).map(function (props) {
    return props[tagName];
  }).reverse().reduce(function (approvedTags, instanceTags) {
    var instanceSeenTags = {};
    instanceTags.filter(function (tag) {
      var primaryAttributeKey;
      var keys2 = Object.keys(tag);
      for (var i = 0; i < keys2.length; i += 1) {
        var attributeKey = keys2[i];
        var lowerCaseAttributeKey = attributeKey.toLowerCase();
        if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */ && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */ && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
          primaryAttributeKey = lowerCaseAttributeKey;
        }
        if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */ || attributeKey === "cssText" /* CSS_TEXT */ || attributeKey === "itemprop" /* ITEM_PROP */)) {
          primaryAttributeKey = attributeKey;
        }
      }
      if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
        return false;
      }
      var value = tag[primaryAttributeKey].toLowerCase();
      if (!approvedSeenTags[primaryAttributeKey]) {
        approvedSeenTags[primaryAttributeKey] = {};
      }
      if (!instanceSeenTags[primaryAttributeKey]) {
        instanceSeenTags[primaryAttributeKey] = {};
      }
      if (!approvedSeenTags[primaryAttributeKey][value]) {
        instanceSeenTags[primaryAttributeKey][value] = true;
        return true;
      }
      return false;
    }).reverse().forEach(function (tag) {
      return approvedTags.push(tag);
    });
    var keys = Object.keys(instanceSeenTags);
    for (var i = 0; i < keys.length; i += 1) {
      var attributeKey = keys[i];
      var tagUnion = _objectSpread(_objectSpread({}, approvedSeenTags[attributeKey]), instanceSeenTags[attributeKey]);
      approvedSeenTags[attributeKey] = tagUnion;
    }
    return approvedTags;
  }, []).reverse();
};
var getAnyTrueFromPropsList = function getAnyTrueFromPropsList(propsList, checkedTag) {
  if (Array.isArray(propsList) && propsList.length) {
    for (var index = 0; index < propsList.length; index += 1) {
      var prop = propsList[index];
      if (prop[checkedTag]) {
        return true;
      }
    }
  }
  return false;
};
var reducePropsToState = function reducePropsToState(propsList) {
  return {
    baseTag: getBaseTagFromPropsList(["href" /* HREF */], propsList),
    bodyAttributes: getAttributesFromPropsList("bodyAttributes" /* BODY */, propsList),
    defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
    encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
    htmlAttributes: getAttributesFromPropsList("htmlAttributes" /* HTML */, propsList),
    linkTags: getTagsFromPropsList("link" /* LINK */, ["rel" /* REL */, "href" /* HREF */], propsList),
    metaTags: getTagsFromPropsList("meta" /* META */, ["name" /* NAME */, "charset" /* CHARSET */, "http-equiv" /* HTTPEQUIV */, "property" /* PROPERTY */, "itemprop" /* ITEM_PROP */], propsList),
    noscriptTags: getTagsFromPropsList("noscript" /* NOSCRIPT */, ["innerHTML" /* INNER_HTML */], propsList),
    onChangeClientState: getOnChangeClientState(propsList),
    scriptTags: getTagsFromPropsList("script" /* SCRIPT */, ["src" /* SRC */, "innerHTML" /* INNER_HTML */], propsList),
    styleTags: getTagsFromPropsList("style" /* STYLE */, ["cssText" /* CSS_TEXT */], propsList),
    title: getTitleFromPropsList(propsList),
    titleAttributes: getAttributesFromPropsList("titleAttributes" /* TITLE */, propsList),
    prioritizeSeoTags: getAnyTrueFromPropsList(propsList, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
  };
};
var flattenArray = function flattenArray(possibleArray) {
  return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var checkIfPropsMatch = function checkIfPropsMatch(props, toMatch) {
  var keys = Object.keys(props);
  for (var i = 0; i < keys.length; i += 1) {
    if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) {
      return true;
    }
  }
  return false;
};
var prioritizer = function prioritizer(elementsList, propsToMatch) {
  if (Array.isArray(elementsList)) {
    return elementsList.reduce(function (acc, elementAttrs) {
      if (checkIfPropsMatch(elementAttrs, propsToMatch)) {
        acc.priority.push(elementAttrs);
      } else {
        acc.default.push(elementAttrs);
      }
      return acc;
    }, {
      priority: [],
      default: []
    });
  }
  return {
    default: elementsList,
    priority: []
  };
};
var without = function without(obj, key) {
  return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, void 0));
};

// src/server.ts
var SELF_CLOSING_TAGS = ["noscript" /* NOSCRIPT */, "script" /* SCRIPT */, "style" /* STYLE */];
var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
  var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  if (encode === false) {
    return String(str);
  }
  return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
  return Object.keys(attributes).reduce(function (str, key) {
    var attr = typeof attributes[key] !== "undefined" ? "".concat(key, "=\"").concat(attributes[key], "\"") : "".concat(key);
    return str ? "".concat(str, " ").concat(attr) : attr;
  }, "");
};
var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
  var attributeString = generateElementAttributesAsString(attributes);
  var flattenedTitle = flattenArray(title);
  return attributeString ? "<".concat(type, " ").concat(HELMET_ATTRIBUTE, "=\"true\" ").concat(attributeString, ">").concat(encodeSpecialCharacters(flattenedTitle, encode), "</").concat(type, ">") : "<".concat(type, " ").concat(HELMET_ATTRIBUTE, "=\"true\">").concat(encodeSpecialCharacters(flattenedTitle, encode), "</").concat(type, ">");
};
var generateTagsAsString = function generateTagsAsString(type, tags) {
  var encode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return tags.reduce(function (str, t) {
    var tag = t;
    var attributeHtml = Object.keys(tag).filter(function (attribute) {
      return !(attribute === "innerHTML" /* INNER_HTML */ || attribute === "cssText" /* CSS_TEXT */);
    }).reduce(function (string, attribute) {
      var attr = typeof tag[attribute] === "undefined" ? attribute : "".concat(attribute, "=\"").concat(encodeSpecialCharacters(tag[attribute], encode), "\"");
      return string ? "".concat(string, " ").concat(attr) : attr;
    }, "");
    var tagContent = tag.innerHTML || tag.cssText || "";
    var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
    return "".concat(str, "<").concat(type, " ").concat(HELMET_ATTRIBUTE, "=\"true\" ").concat(attributeHtml).concat(isSelfClosing ? "/>" : ">".concat(tagContent, "</").concat(type, ">"));
  }, "");
};
var convertElementAttributesToReactProps = function convertElementAttributesToReactProps(attributes) {
  var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object.keys(attributes).reduce(function (obj, key) {
    var mapped = REACT_TAG_MAP[key];
    obj[mapped || key] = attributes[key];
    return obj;
  }, initProps);
};
var generateTitleAsReactComponent = function generateTitleAsReactComponent(_type, title, attributes) {
  var initProps = _defineProperty({
    key: title
  }, HELMET_ATTRIBUTE, true);
  var props = convertElementAttributesToReactProps(attributes, initProps);
  return [React.createElement("title" /* TITLE */, props, title)];
};
var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
  return tags.map(function (tag, i) {
    var mappedTag = _defineProperty({
      key: i
    }, HELMET_ATTRIBUTE, true);
    Object.keys(tag).forEach(function (attribute) {
      var mapped = REACT_TAG_MAP[attribute];
      var mappedAttribute = mapped || attribute;
      if (mappedAttribute === "innerHTML" /* INNER_HTML */ || mappedAttribute === "cssText" /* CSS_TEXT */) {
        var content = tag.innerHTML || tag.cssText;
        mappedTag.dangerouslySetInnerHTML = {
          __html: content
        };
      } else {
        mappedTag[mappedAttribute] = tag[attribute];
      }
    });
    return React.createElement(type, mappedTag);
  });
};
var getMethodsForTag = function getMethodsForTag(type, tags) {
  var encode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  switch (type) {
    case "title" /* TITLE */:
      return {
        toComponent: function toComponent() {
          return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes);
        },
        toString: function toString() {
          return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
        }
      };
    case "bodyAttributes" /* BODY */:
    case "htmlAttributes" /* HTML */:
      return {
        toComponent: function toComponent() {
          return convertElementAttributesToReactProps(tags);
        },
        toString: function toString() {
          return generateElementAttributesAsString(tags);
        }
      };
    default:
      return {
        toComponent: function toComponent() {
          return generateTagsAsReactComponent(type, tags);
        },
        toString: function toString() {
          return generateTagsAsString(type, tags, encode);
        }
      };
  }
};
var getPriorityMethods = function getPriorityMethods(_ref3) {
  var metaTags = _ref3.metaTags,
    linkTags = _ref3.linkTags,
    scriptTags = _ref3.scriptTags,
    encode = _ref3.encode;
  var meta = prioritizer(metaTags, SEO_PRIORITY_TAGS.meta);
  var link = prioritizer(linkTags, SEO_PRIORITY_TAGS.link);
  var script = prioritizer(scriptTags, SEO_PRIORITY_TAGS.script);
  var priorityMethods = {
    toComponent: function toComponent() {
      return [].concat(_toConsumableArray(generateTagsAsReactComponent("meta" /* META */, meta.priority)), _toConsumableArray(generateTagsAsReactComponent("link" /* LINK */, link.priority)), _toConsumableArray(generateTagsAsReactComponent("script" /* SCRIPT */, script.priority)));
    },
    toString: function toString() {
      return (// generate all the tags as strings and concatenate them
        "".concat(getMethodsForTag("meta" /* META */, meta.priority, encode), " ").concat(getMethodsForTag("link" /* LINK */, link.priority, encode), " ").concat(getMethodsForTag("script" /* SCRIPT */, script.priority, encode))
      );
    }
  };
  return {
    priorityMethods: priorityMethods,
    metaTags: meta.default,
    linkTags: link.default,
    scriptTags: script.default
  };
};
var mapStateOnServer = function mapStateOnServer(props) {
  var baseTag = props.baseTag,
    bodyAttributes = props.bodyAttributes,
    _props$encode = props.encode,
    encode = _props$encode === void 0 ? true : _props$encode,
    htmlAttributes = props.htmlAttributes,
    noscriptTags = props.noscriptTags,
    styleTags = props.styleTags,
    _props$title = props.title,
    title = _props$title === void 0 ? "" : _props$title,
    titleAttributes = props.titleAttributes,
    prioritizeSeoTags = props.prioritizeSeoTags;
  var linkTags = props.linkTags,
    metaTags = props.metaTags,
    scriptTags = props.scriptTags;
  var priorityMethods = {
    toComponent: function toComponent() {},
    toString: function toString() {
      return "";
    }
  };
  if (prioritizeSeoTags) {
    var _getPriorityMethods = getPriorityMethods(props);
    priorityMethods = _getPriorityMethods.priorityMethods;
    linkTags = _getPriorityMethods.linkTags;
    metaTags = _getPriorityMethods.metaTags;
    scriptTags = _getPriorityMethods.scriptTags;
  }
  return {
    priority: priorityMethods,
    base: getMethodsForTag("base" /* BASE */, baseTag, encode),
    bodyAttributes: getMethodsForTag("bodyAttributes" /* BODY */, bodyAttributes, encode),
    htmlAttributes: getMethodsForTag("htmlAttributes" /* HTML */, htmlAttributes, encode),
    link: getMethodsForTag("link" /* LINK */, linkTags, encode),
    meta: getMethodsForTag("meta" /* META */, metaTags, encode),
    noscript: getMethodsForTag("noscript" /* NOSCRIPT */, noscriptTags, encode),
    script: getMethodsForTag("script" /* SCRIPT */, scriptTags, encode),
    style: getMethodsForTag("style" /* STYLE */, styleTags, encode),
    title: getMethodsForTag("title" /* TITLE */, {
      title: title,
      titleAttributes: titleAttributes
    }, encode)
  };
};
var server_default = mapStateOnServer;

// src/HelmetData.ts
var instances = [];
var isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var HelmetData = /*#__PURE__*/_createClass(function HelmetData(context, canUseDOM) {
  var _this = this;
  _classCallCheck(this, HelmetData);
  _defineProperty(this, "instances", []);
  _defineProperty(this, "canUseDOM", isDocument);
  _defineProperty(this, "context", void 0);
  _defineProperty(this, "value", {
    setHelmet: function setHelmet(serverState) {
      _this.context.helmet = serverState;
    },
    helmetInstances: {
      get: function get() {
        return _this.canUseDOM ? instances : _this.instances;
      },
      add: function add(instance) {
        (_this.canUseDOM ? instances : _this.instances).push(instance);
      },
      remove: function remove(instance) {
        var index = (_this.canUseDOM ? instances : _this.instances).indexOf(instance);
        (_this.canUseDOM ? instances : _this.instances).splice(index, 1);
      }
    }
  });
  this.context = context;
  this.canUseDOM = canUseDOM || false;
  if (!canUseDOM) {
    context.helmet = server_default({
      baseTag: [],
      bodyAttributes: {},
      encodeSpecialCharacters: true,
      htmlAttributes: {},
      linkTags: [],
      metaTags: [],
      noscriptTags: [],
      scriptTags: [],
      styleTags: [],
      title: "",
      titleAttributes: {}
    });
  }
});

// src/Provider.tsx
var defaultValue = {};
var Context = React2.createContext(defaultValue);
var HelmetProvider = (_HelmetProvider2 = /*#__PURE__*/function (_Component) {
  function _HelmetProvider(props) {
    var _this2;
    _classCallCheck(this, _HelmetProvider);
    _this2 = _callSuper(this, _HelmetProvider, [props]);
    _defineProperty(_this2, "helmetData", void 0);
    _this2.helmetData = new HelmetData(_this2.props.context || {}, _HelmetProvider.canUseDOM);
    return _this2;
  }
  _inherits(_HelmetProvider, _Component);
  return _createClass(_HelmetProvider, [{
    key: "render",
    value: function render() {
      return /* @__PURE__ */React2.createElement(Context.Provider, {
        value: this.helmetData.value
      }, this.props.children);
    }
  }]);
}(Component), _defineProperty(_HelmetProvider2, "canUseDOM", isDocument), _HelmetProvider2);

// src/Dispatcher.tsx
import { Component as Component2 } from "react";
import shallowEqual from "shallowequal";

// src/client.ts
var updateTags = function updateTags(type, tags) {
  var headElement = document.head || document.querySelector("head" /* HEAD */);
  var tagNodes = headElement.querySelectorAll("".concat(type, "[").concat(HELMET_ATTRIBUTE, "]"));
  var oldTags = [].slice.call(tagNodes);
  var newTags = [];
  var indexToDelete;
  if (tags && tags.length) {
    tags.forEach(function (tag) {
      var newElement = document.createElement(type);
      for (var attribute in tag) {
        if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
          if (attribute === "innerHTML" /* INNER_HTML */) {
            newElement.innerHTML = tag.innerHTML;
          } else if (attribute === "cssText" /* CSS_TEXT */) {
            if (newElement.styleSheet) {
              newElement.styleSheet.cssText = tag.cssText;
            } else {
              newElement.appendChild(document.createTextNode(tag.cssText));
            }
          } else {
            var attr = attribute;
            var value = typeof tag[attr] === "undefined" ? "" : tag[attr];
            newElement.setAttribute(attribute, value);
          }
        }
      }
      newElement.setAttribute(HELMET_ATTRIBUTE, "true");
      if (oldTags.some(function (existingTag, index) {
        indexToDelete = index;
        return newElement.isEqualNode(existingTag);
      })) {
        oldTags.splice(indexToDelete, 1);
      } else {
        newTags.push(newElement);
      }
    });
  }
  oldTags.forEach(function (tag) {
    var _tag$parentNode;
    return (_tag$parentNode = tag.parentNode) === null || _tag$parentNode === void 0 ? void 0 : _tag$parentNode.removeChild(tag);
  });
  newTags.forEach(function (tag) {
    return headElement.appendChild(tag);
  });
  return {
    oldTags: oldTags,
    newTags: newTags
  };
};
var updateAttributes = function updateAttributes(tagName, attributes) {
  var elementTag = document.getElementsByTagName(tagName)[0];
  if (!elementTag) {
    return;
  }
  var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
  var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
  var attributesToRemove = _toConsumableArray(helmetAttributes);
  var attributeKeys = Object.keys(attributes);
  for (var _i = 0, _attributeKeys = attributeKeys; _i < _attributeKeys.length; _i++) {
    var attribute = _attributeKeys[_i];
    var value = attributes[attribute] || "";
    if (elementTag.getAttribute(attribute) !== value) {
      elementTag.setAttribute(attribute, value);
    }
    if (helmetAttributes.indexOf(attribute) === -1) {
      helmetAttributes.push(attribute);
    }
    var indexToSave = attributesToRemove.indexOf(attribute);
    if (indexToSave !== -1) {
      attributesToRemove.splice(indexToSave, 1);
    }
  }
  for (var i = attributesToRemove.length - 1; i >= 0; i -= 1) {
    elementTag.removeAttribute(attributesToRemove[i]);
  }
  if (helmetAttributes.length === attributesToRemove.length) {
    elementTag.removeAttribute(HELMET_ATTRIBUTE);
  } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
    elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
  }
};
var updateTitle = function updateTitle(title, attributes) {
  if (typeof title !== "undefined" && document.title !== title) {
    document.title = flattenArray(title);
  }
  updateAttributes("title" /* TITLE */, attributes);
};
var commitTagChanges = function commitTagChanges(newState, cb) {
  var baseTag = newState.baseTag,
    bodyAttributes = newState.bodyAttributes,
    htmlAttributes = newState.htmlAttributes,
    linkTags = newState.linkTags,
    metaTags = newState.metaTags,
    noscriptTags = newState.noscriptTags,
    onChangeClientState = newState.onChangeClientState,
    scriptTags = newState.scriptTags,
    styleTags = newState.styleTags,
    title = newState.title,
    titleAttributes = newState.titleAttributes;
  updateAttributes("body" /* BODY */, bodyAttributes);
  updateAttributes("html" /* HTML */, htmlAttributes);
  updateTitle(title, titleAttributes);
  var tagUpdates = {
    baseTag: updateTags("base" /* BASE */, baseTag),
    linkTags: updateTags("link" /* LINK */, linkTags),
    metaTags: updateTags("meta" /* META */, metaTags),
    noscriptTags: updateTags("noscript" /* NOSCRIPT */, noscriptTags),
    scriptTags: updateTags("script" /* SCRIPT */, scriptTags),
    styleTags: updateTags("style" /* STYLE */, styleTags)
  };
  var addedTags = {};
  var removedTags = {};
  Object.keys(tagUpdates).forEach(function (tagType) {
    var _tagUpdates$tagType = tagUpdates[tagType],
      newTags = _tagUpdates$tagType.newTags,
      oldTags = _tagUpdates$tagType.oldTags;
    if (newTags.length) {
      addedTags[tagType] = newTags;
    }
    if (oldTags.length) {
      removedTags[tagType] = tagUpdates[tagType].oldTags;
    }
  });
  if (cb) {
    cb();
  }
  onChangeClientState(newState, addedTags, removedTags);
};
var _helmetCallback = null;
var handleStateChangeOnClient = function handleStateChangeOnClient(newState) {
  if (_helmetCallback) {
    cancelAnimationFrame(_helmetCallback);
  }
  if (newState.defer) {
    _helmetCallback = requestAnimationFrame(function () {
      commitTagChanges(newState, function () {
        _helmetCallback = null;
      });
    });
  } else {
    commitTagChanges(newState);
    _helmetCallback = null;
  }
};
var client_default = handleStateChangeOnClient;

// src/Dispatcher.tsx
var HelmetDispatcher = /*#__PURE__*/function (_Component2) {
  function HelmetDispatcher() {
    var _this3;
    _classCallCheck(this, HelmetDispatcher);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this3 = _callSuper(this, HelmetDispatcher, [].concat(args));
    _defineProperty(_this3, "rendered", false);
    return _this3;
  }
  _inherits(HelmetDispatcher, _Component2);
  return _createClass(HelmetDispatcher, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !shallowEqual(nextProps, this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var helmetInstances = this.props.context.helmetInstances;
      helmetInstances.remove(this);
      this.emitChange();
    }
  }, {
    key: "emitChange",
    value: function emitChange() {
      var _this$props$context = this.props.context,
        helmetInstances = _this$props$context.helmetInstances,
        setHelmet = _this$props$context.setHelmet;
      var serverState = null;
      var state = reducePropsToState(helmetInstances.get().map(function (instance) {
        var props = _objectSpread({}, instance.props);
        delete props.context;
        return props;
      }));
      if (HelmetProvider.canUseDOM) {
        client_default(state);
      } else if (server_default) {
        serverState = server_default(state);
      }
      setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
  }, {
    key: "init",
    value: function init() {
      if (this.rendered) {
        return;
      }
      this.rendered = true;
      var helmetInstances = this.props.context.helmetInstances;
      helmetInstances.add(this);
      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      this.init();
      return null;
    }
  }]);
}(Component2);

// src/index.tsx
var Helmet = (_Class3 = /*#__PURE__*/function (_Component3) {
  function Helmet() {
    _classCallCheck(this, Helmet);
    return _callSuper(this, Helmet, arguments);
  }
  _inherits(Helmet, _Component3);
  return _createClass(Helmet, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !fastCompare(without(this.props, "helmetData"), without(nextProps, "helmetData"));
    }
  }, {
    key: "mapNestedChildrenToProps",
    value: function mapNestedChildrenToProps(child, nestedChildren) {
      if (!nestedChildren) {
        return null;
      }
      switch (child.type) {
        case "script" /* SCRIPT */:
        case "noscript" /* NOSCRIPT */:
          return {
            innerHTML: nestedChildren
          };
        case "style" /* STYLE */:
          return {
            cssText: nestedChildren
          };
        default:
          throw new Error("<".concat(child.type, " /> elements are self-closing and can not contain children. Refer to our API for more information."));
      }
    }
  }, {
    key: "flattenArrayTypeChildren",
    value: function flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
      return _objectSpread(_objectSpread({}, arrayTypeChildren), {}, _defineProperty({}, child.type, [].concat(_toConsumableArray(arrayTypeChildren[child.type] || []), [_objectSpread(_objectSpread({}, newChildProps), this.mapNestedChildrenToProps(child, nestedChildren))])));
    }
  }, {
    key: "mapObjectTypeChildren",
    value: function mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
      switch (child.type) {
        case "title" /* TITLE */:
          return _objectSpread(_objectSpread({}, newProps), {}, _defineProperty(_defineProperty({}, child.type, nestedChildren), "titleAttributes", _objectSpread({}, newChildProps)));
        case "body" /* BODY */:
          return _objectSpread(_objectSpread({}, newProps), {}, {
            bodyAttributes: _objectSpread({}, newChildProps)
          });
        case "html" /* HTML */:
          return _objectSpread(_objectSpread({}, newProps), {}, {
            htmlAttributes: _objectSpread({}, newChildProps)
          });
        default:
          return _objectSpread(_objectSpread({}, newProps), {}, _defineProperty({}, child.type, _objectSpread({}, newChildProps)));
      }
    }
  }, {
    key: "mapArrayTypeChildrenToProps",
    value: function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
      var newFlattenedProps = _objectSpread({}, newProps);
      Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
        newFlattenedProps = _objectSpread(_objectSpread({}, newFlattenedProps), {}, _defineProperty({}, arrayChildName, arrayTypeChildren[arrayChildName]));
      });
      return newFlattenedProps;
    }
  }, {
    key: "warnOnInvalidChildren",
    value: function warnOnInvalidChildren(child, nestedChildren) {
      invariant(VALID_TAG_NAMES.some(function (name) {
        return child.type === name;
      }), typeof child.type === "function" ? "You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information." : "Only elements types ".concat(VALID_TAG_NAMES.join(", "), " are allowed. Helmet does not support rendering <").concat(child.type, "> elements. Refer to our API for more information."));
      invariant(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some(function (nestedChild) {
        return typeof nestedChild !== "string";
      }), "Helmet expects a string as a child of <".concat(child.type, ">. Did you forget to wrap your children in braces? ( <").concat(child.type, ">{``}</").concat(child.type, "> ) Refer to our API for more information."));
      return true;
    }
  }, {
    key: "mapChildrenToProps",
    value: function mapChildrenToProps(children, newProps) {
      var _this4 = this;
      var arrayTypeChildren = {};
      React3.Children.forEach(children, function (child) {
        if (!child || !child.props) {
          return;
        }
        var _child$props = child.props,
          nestedChildren = _child$props.children,
          childProps = _objectWithoutProperties(_child$props, _excluded);
        var newChildProps = Object.keys(childProps).reduce(function (obj, key) {
          obj[HTML_TAG_MAP[key] || key] = childProps[key];
          return obj;
        }, {});
        var type = child.type;
        if (typeof type === "symbol") {
          type = type.toString();
        } else {
          _this4.warnOnInvalidChildren(child, nestedChildren);
        }
        switch (type) {
          case "Symbol(react.fragment)" /* FRAGMENT */:
            newProps = _this4.mapChildrenToProps(nestedChildren, newProps);
            break;
          case "link" /* LINK */:
          case "meta" /* META */:
          case "noscript" /* NOSCRIPT */:
          case "script" /* SCRIPT */:
          case "style" /* STYLE */:
            arrayTypeChildren = _this4.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
            break;
          default:
            newProps = _this4.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
            break;
        }
      });
      return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        children = _this$props.children,
        props = _objectWithoutProperties(_this$props, _excluded2);
      var newProps = _objectSpread({}, props);
      var helmetData = props.helmetData;
      if (children) {
        newProps = this.mapChildrenToProps(children, newProps);
      }
      if (helmetData && !(helmetData instanceof HelmetData)) {
        var data = helmetData;
        helmetData = new HelmetData(data.context, true);
        delete newProps.helmetData;
      }
      return helmetData ? /* @__PURE__ */React3.createElement(HelmetDispatcher, _objectSpread(_objectSpread({}, newProps), {}, {
        context: helmetData.value
      })) : /* @__PURE__ */React3.createElement(Context.Consumer, null, function (context) {
        return /* @__PURE__ */React3.createElement(HelmetDispatcher, _objectSpread(_objectSpread({}, newProps), {}, {
          context: context
        }));
      });
    }
  }]);
}(Component3), _defineProperty(_Class3, "defaultProps", {
  defer: true,
  encodeSpecialCharacters: true,
  prioritizeSeoTags: false
}), _Class3);
export { Helmet, HelmetData, HelmetProvider };